import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './modules/app/components/App';
import configureStore from './store/configureStore';
import reportWebVitals from './reportWebVitals';
import 'semantic-ui-css/semantic.min.css'
import './fonts/Roboto/Roboto-Medium.ttf';


const store = configureStore();
ReactDOM.render(
  <React.StrictMode>
    <App store={store}/>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
